import React, { Component } from "react";
import Rail from "./rail";

class SideRailComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <Rail api={this.props} />
    );
  }
}

export default SideRailComponent;
